import { axios } from "..";

export interface BeefreeTokenResponse {
  access_token: string;
  v2?: boolean;
}

/**
 * Get Beefree SDK token (server-to-server). Returns the full auth response { access_token, v2 }
 * for use with new BeefreeSDK(token). Tokens are valid 12 hours; use bee.updateToken() to refresh.
 */
export const getBeefreeToken = async (): Promise<BeefreeTokenResponse> => {
  const envToken = process.env.REACT_APP_BEEFREE_TOKEN?.trim();
  if (envToken) {
    return { access_token: envToken, v2: true };
  }
  try {
    const response = await axios.Get("./beefreeToken");
    const data = response?.data as { access_token?: string; v2?: boolean };
    if (!data?.access_token) {
      throw new Error("No token in response");
    }
    return { access_token: data.access_token, v2: data.v2 ?? true };
  } catch (e: unknown) {
    const status = (e as { response?: { status?: number } })?.response?.status;
    if (status === 404 || status === 501) {
      throw new Error((e as Error)?.message ?? "Token endpoint unavailable");
    }
    throw e;
  }
};
